export default __webpack_public_path__ + "static/media/4_Still.f30f6147.jpg";